import React, { useState } from 'react';

import QuestionForm from './questionForm';
import GroupForm from './groupForm';

export default function CopperInternet() {
  // const [serviceList, setServiceList] = useState([]);

  return (
    <div>
      {/* <QuestionForm /> */}
      <GroupForm />
    </div>
  );
}
